import React, { useState, useEffect } from 'react';
import Heading from '../../../../../../components/heading/heading';
import '../../../../../../pages/Dashboard/components/ErrorDialog/ErrorDialog.scss';
import { Form, Checkbox, Button } from 'antd';
import { AuthWrapper } from '../../style';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../../../../redux/authentication/api';
import { submitCddFundData } from '../../../../../../redux/authentication/actionCreator';

function CddError() {
  const [form] = Form.useForm();
  const [state, setState] = useState(true);
  const [sourceOfFunds, setSourceOfFunds] = useState(null);
  const [sourceOfWealth, setSourceOfWealth] = useState(null);
  const [checkedSourceOfFunds, setCheckedSourceOfFunds] = useState(null);
  const [checkedSourceOfWealth, setCheckedSourceOfWealth] = useState(null);
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.auth.loading);
  const referenceId = useSelector(state => state.auth.dataForm.customerId);

  const submitCddData = () => {
    if (
      checkedSourceOfFunds === null ||
      checkedSourceOfFunds.length === 0 ||
      checkedSourceOfWealth === null ||
      checkedSourceOfWealth.length === 0
    ) {
      return;
    }
    let param = {
      customerId: `${referenceId}`,
      sourceOfFunds: checkedSourceOfFunds,
      sourceOfWealth: checkedSourceOfWealth,
    };
    dispatch(submitCddFundData(param));
  };

  useEffect(() => {
    const getFundSources = async () => {
      if (!sourceOfFunds) {
        let data = await api.get('/signup/kyc/fund/source?language=MS');
        setSourceOfFunds(data.data);
      }
    };
    getFundSources();
  }, [sourceOfFunds]);

  useEffect(() => {
    const getsourceOfWealth = async () => {
      if (!sourceOfFunds) {
        let data = await api.get('/signup/kyc/wealth/source?language=MS');
        setSourceOfWealth(data.data);
      }
    };
    getsourceOfWealth();
  }, [sourceOfWealth]);

  const handleChange = value => {
    // console.log(`selected ${value}`);
  };

  const onChangeSourceOfWealth = checkedValues => {
    setCheckedSourceOfWealth(checkedValues);
    if (checkedSourceOfFunds !== null && checkedValues !== 0) {
      setState(false);
    }
    if (checkedValues.length === 0) {
      setState(true);
    }
  };
  const onChangeSourceOfFunds = checkedValues => {
    setCheckedSourceOfFunds(checkedValues);
    if (checkedValues !== 0 && checkedSourceOfWealth !== null) {
      setState(false);
    }
    if (checkedValues.length === 0) {
      setState(true);
    }
  };

  return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form name="login" form={form} onFinish={handleChange} layout="vertical">
          <Heading as="h5">Maklumat mengenai dana</Heading>

          <Form.Item
            name="sourceOfFunds"
            rules={[{ message: 'Sources of Funds Required', required: true }]}
            label="Sumber Dana"
          >
            <Checkbox.Group
              style={{
                display: 'flex',
                position: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                alignItems: 'self-start',
              }}
              options={sourceOfFunds}
              onChange={onChangeSourceOfFunds}
            />
          </Form.Item>
          <Form.Item
            name="sourceOfWealth"
            rules={[{ message: 'Sources of Wealth Required', required: true }]}
            label="Sumber Kekayaan"
          >
            <Checkbox.Group
              style={{
                display: 'flex',
                position: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                alignItems: 'self-start',
              }}
              options={sourceOfWealth}
              onChange={onChangeSourceOfWealth}
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="btn-create"
              htmlType="submit"
              type="primary"
              size="middle"
              onClick={submitCddData}
              disabled={state || isLoading}
            >
              {isLoading ? 'Loading...' : 'Serahkan'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </AuthWrapper>
  );
}

export default CddError;
